import { Company } from 'type/company';
import { DefaultSuccess } from 'type/http';
import Request from './request';

const request = new Request('pivot');

type DeletedType = 1 | 2 | 3

/**
 * 查询用户所关联的所有企业
 * @param deletedType 0-全部 1-未删除 2-已删除
 */
export const getCompanyList = (deletedType: DeletedType = 1) => {
  return request.get<Company[]>(`/api/user/staffs?deletedType=${deletedType}`);
};

/**
 * 切换企业
 * @param staffId
 */
export const switchCompany = (staffId: string) => {
  return request.post<DefaultSuccess>('/api/user/staff-choices', {
    staffId
  });
};
